<template>
  <div class="page_content">
    <template v-if="loading">
      <div class="component_loader">
        <spinner :status="loading" />
      </div>
    </template>
    <template
      v-else-if="
        displayedEmployees.all.length ||
        displayedEmployees.expired.length ||
        displayedEmployees.thirty_days.length ||
        displayedEmployees.sixty_days.length ||
        displayedEmployees.internship_seven_days.length ||
        displayedEmployees.internship_fifteen_days.length
      "
    >
      <div class="boxi m-t-20">
        <ul class="inlineListinJobDetails text-center">
          <li
            @click="getEmployeesWithNormalContracts(1)"
            :class="status === 1 ? 'activeli' : ''"
          >
            Normal contracts
          </li>
          <li
            @click="getEmployeesWithInternshipContracts(0)"
            :class="status === 0 ? 'activeli' : ''"
          >
            Internship contracts
          </li>
        </ul>
      </div>
      <div class="page_content">
        <div class="" v-if="displayedEmployees.expired.length">
          <div class="textinBox">
            <h4>{{ $t('account_settings.expiredcontract') }}</h4>
          </div>
          <div>
            <div v-if="displayedEmployees.expired.length">
              <div class="row">
                <div
                  class="col-md-4 m-t-10"
                  v-for="employee_item in displayedEmployees.expired"
                  :key="employee_item.employee_id"
                >
                  <div
                    class="boxi"
                    @click="view_profile(employee_item.employee_id)"
                  >
                    <div class="row">
                      <div class="col-2">
                        <template
                          v-if="
                            employee_item.image_url == '' ||
                            employee_item.image_url == null ||
                            employee_item.image_url == undefined
                          "
                        >
                          <img
                            src="/images/user/no-image.png"
                            class="imgCandidate"
                          />
                        </template>
                        <template v-else>
                          <img
                            :src="
                              SERVER_URL +
                              IMAGES_FILES +
                              employee_item.image_url
                            "
                            class="imgCandidate"
                          />
                        </template>
                      </div>
                      <div class="col-10">
                        <div class="textinBoxCandidateDetails">
                          <h4>
                            {{ employee_item.name }} {{ employee_item.surname }}
                          </h4>
                          <h5 />
                          <h5>
                            {{
                              employee_item.contract_end_date
                                | moment('DD/MM/YYYY')
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="m-t-20"
          v-if="status === 0 && displayedEmployees.internship_seven_days.length"
        >
          <div class="textinBox">
            <h4>{{ $t('account_settings.employeecontracts_intern_7') }}</h4>
          </div>
          <div>
            <div v-if="displayedEmployees.internship_seven_days.length">
              <div class="row">
                <div
                  class="col-md-4 m-t-10"
                  v-for="employee_item in displayedEmployees.internship_seven_days"
                  :key="employee_item.employee_id"
                >
                  <div
                    class="boxi"
                    @click="view_profile(employee_item.employee_id)"
                  >
                    <div class="row">
                      <div class="col-2">
                        <template
                          v-if="
                            employee_item.image_url == '' ||
                            employee_item.image_url == null ||
                            employee_item.image_url == undefined
                          "
                        >
                          <img
                            src="/images/user/no-image.png"
                            class="imgCandidate"
                          />
                        </template>
                        <template v-else>
                          <img
                            :src="
                              SERVER_URL +
                              IMAGES_FILES +
                              employee_item.image_url
                            "
                            class="imgCandidate"
                          />
                        </template>
                      </div>
                      <div class="col-10">
                        <div class="textinBoxCandidateDetails">
                          <h4>
                            {{ employee_item.name }} {{ employee_item.surname }}
                          </h4>
                          <h5 />
                          <h5>
                            {{
                              employee_item.contract_end_date
                                | moment('DD/MM/YYYY')
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="m-t-20"
          v-if="
            status === 0 && displayedEmployees.internship_fifteen_days.length
          "
        >
          <div class="textinBox">
            <h4>{{ $t('account_settings.employeecontracts_intern_15') }}</h4>
          </div>
          <div>
            <div v-if="displayedEmployees.internship_fifteen_days.length">
              <div class="row">
                <div
                  class="col-md-4 m-t-10"
                  v-for="employee_item in displayedEmployees.internship_fifteen_days"
                  :key="employee_item.employee_id"
                >
                  <div
                    class="boxi"
                    @click="view_profile(employee_item.employee_id)"
                  >
                    <div class="row">
                      <div class="col-2">
                        <template
                          v-if="
                            employee_item.image_url == '' ||
                            employee_item.image_url == null ||
                            employee_item.image_url == undefined
                          "
                        >
                          <img
                            src="/images/user/no-image.png"
                            class="imgCandidate"
                          />
                        </template>
                        <template v-else>
                          <img
                            :src="
                              SERVER_URL +
                              IMAGES_FILES +
                              employee_item.image_url
                            "
                            class="imgCandidate"
                          />
                        </template>
                      </div>
                      <div class="col-10">
                        <div class="textinBoxCandidateDetails">
                          <h4>
                            {{ employee_item.name }} {{ employee_item.surname }}
                          </h4>
                          <h5 />
                          <h5>
                            {{
                              employee_item.contract_end_date
                                | moment('DD/MM/YYYY')
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="m-t-20"
          v-if="status === 1 && displayedEmployees.thirty_days.length"
        >
          <div class="textinBox">
            <h4>{{ $t('account_settings.employeecontracts30') }}</h4>
          </div>
          <div>
            <div v-if="displayedEmployees.thirty_days.length">
              <div class="row">
                <div
                  class="col-md-4 m-t-10"
                  v-for="employee_item in displayedEmployees.thirty_days"
                  :key="employee_item.employee_id"
                >
                  <div
                    class="boxi"
                    @click="view_profile(employee_item.employee_id)"
                  >
                    <div class="row">
                      <div class="col-2">
                        <template
                          v-if="
                            employee_item.image_url == '' ||
                            employee_item.image_url == null ||
                            employee_item.image_url == undefined
                          "
                        >
                          <img
                            src="/images/user/no-image.png"
                            class="imgCandidate"
                          />
                        </template>
                        <template v-else>
                          <img
                            :src="
                              SERVER_URL +
                              IMAGES_FILES +
                              employee_item.image_url
                            "
                            class="imgCandidate"
                          />
                        </template>
                      </div>
                      <div class="col-10">
                        <div class="textinBoxCandidateDetails">
                          <h4>
                            {{ employee_item.name }} {{ employee_item.surname }}
                          </h4>
                          <h5 />
                          <h5>
                            {{
                              employee_item.contract_end_date
                                | moment('DD/MM/YYYY')
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="m-t-20"
          v-if="status === 1 && displayedEmployees.sixty_days.length"
        >
          <div class="textinBox">
            <h4>{{ $t('account_settings.employeecontracts60') }}</h4>
          </div>
          <div>
            <div>
              <div class="row">
                <div
                  class="col-md-4 m-t-10"
                  v-for="employee_item in displayedEmployees.sixty_days"
                  :key="employee_item.employee_id"
                >
                  <div
                    class="boxi"
                    @click="view_profile(employee_item.employee_id)"
                  >
                    <div class="row">
                      <div class="col-2">
                        <template
                          v-if="
                            employee_item.image_url == '' ||
                            employee_item.image_url == null ||
                            employee_item.image_url == undefined
                          "
                        >
                          <img
                            src="/images/user/no-image.png"
                            class="imgCandidate"
                          />
                        </template>
                        <template v-else>
                          <img
                            :src="
                              SERVER_URL +
                              IMAGES_FILES +
                              employee_item.image_url
                            "
                            class="imgCandidate"
                          />
                        </template>
                      </div>
                      <div class="col-10">
                        <div class="textinBoxCandidateDetails">
                          <h4>
                            {{ employee_item.name }} {{ employee_item.surname }}
                          </h4>
                          <h5 />
                          <h5>
                            {{
                              employee_item.contract_end_date
                                | moment('DD/MM/YYYY')
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="m-t-20" v-if="displayedEmployees.all.length">
          <div class="textinBox">
            <h4>
              {{
                status === 1
                  ? $t('account_settings.employeecontracts_all_normal')
                  : $t('account_settings.employeecontracts_all_interns')
              }}
            </h4>
          </div>
          <div>
            <div v-if="displayedEmployees.all.length">
              <div class="row">
                <div
                  class="col-md-4 m-t-10"
                  v-for="employee_item in displayedEmployees.all"
                  :key="employee_item.employee_id"
                >
                  <div
                    class="boxi"
                    @click="view_profile(employee_item.employee_id)"
                  >
                    <div class="row">
                      <div class="col-2">
                        <template
                          v-if="
                            employee_item.image_url == '' ||
                            employee_item.image_url == null ||
                            employee_item.image_url == undefined
                          "
                        >
                          <img
                            src="/images/user/no-image.png"
                            class="imgCandidate"
                          />
                        </template>
                        <template v-else>
                          <img
                            :src="
                              SERVER_URL +
                              IMAGES_FILES +
                              employee_item.image_url
                            "
                            class="imgCandidate"
                          />
                        </template>
                      </div>
                      <div class="col-10">
                        <div class="textinBoxCandidateDetails">
                          <h4>
                            {{ employee_item.name }} {{ employee_item.surname }}
                          </h4>
                          <h5 />
                          <h5>
                            {{
                              employee_item.contract_end_date
                                | moment('DD/MM/YYYY')
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="textinBox">
        <h4>{{ $t('account_settings.noexpiringcontracts') }}</h4>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  inject: {},

  components: {},

  computed: {
    employeesAllList() {
      const payload = this.employees
      if (
        payload &&
        typeof payload === 'object' &&
        Array.isArray(payload.all)
      ) {
        return payload.all
      }
      return []
    },
    displayedEmployees() {
      const isInternshipTab = this.status === 0
      const groups = {
        all: [],
        expired: [],
        thirty_days: [],
        sixty_days: [],
        internship_seven_days: [],
        internship_fifteen_days: []
      }

      // Only filter by intern/internship tab, do not recalculate groups
      Object.keys(groups).forEach((key) => {
        if (Array.isArray(this.employees[key])) {
          groups[key] = this.employees[key].filter((employee) => {
            const isIntern = this.isEmployeeIntern(employee)
            return isInternshipTab ? isIntern : !isIntern
          })
        }
      })

      return groups
    }
  },

  watch: {},

  data() {
    return {
      employees: {
        all: [],
        expired: [],
        sixty_days: [],
        thirty_days: []
      },
      loading: true,
      status: 1 // 1-active, 0-inactive
    }
  },

  methods: {
    getEmployeesWithNormalContracts() {
      this.getEmployees(1)
    },
    getEmployeesWithInternshipContracts() {
      this.getEmployees(0)
    },
    getEmployees(status) {
      this.status = status
    },
    isEmployeeIntern(employee) {
      const raw = employee && employee.internship
      if (raw === true) return true
      if (raw === 1 || raw === '1') return true
      return false
    },
    getEmployeesContract: function () {
      this.loading = true
      this.$store
        .dispatch('company_data/employee/employees/get_employee_contracts')
        .then((response) => {
          this.employees = response.data || {
            all: [],
            expired: [],
            sixty_days: [],
            thirty_days: []
          }
          this.loading = false
        })
    },
    view_profile: function (employee_id) {
      this.$router.push({
        path: '/app/company/employee/profile/' + employee_id + '/contract'
      })
    }
  },

  created() {
    this.getEmployeesContract()
  }
}
</script>
<style>
.title-contract {
  font-weight: 13px;
}
</style>
